"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicMultiDropDown = exports.MultiDropDown = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownButton = _interopRequireDefault(require("react-bootstrap/lib/DropdownButton"));

var _dropdownButtonTethered = _interopRequireDefault(require("./dropdown-button-tethered"));

var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));

var _Checkbox = _interopRequireDefault(require("react-bootstrap/lib/Checkbox"));

var _MenuItem = _interopRequireDefault(require("react-bootstrap/lib/MenuItem"));

var _ThemeProvider = require("../ThemeProvider");

var _utils = require("../../utils");

var _style = _interopRequireDefault(require("./style"));

var _Icon = _interopRequireDefault(require("../Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BasicMultiDropDown = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(BasicMultiDropDown, _React$Component);

  var _super = _createSuper(BasicMultiDropDown);

  function BasicMultiDropDown(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BasicMultiDropDown);
    _this = _super.call(this, _props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedOptions", function (_ref) {
      var defaultValues = _ref.defaultValues,
          value = _ref.value;

      if (defaultValues == null && value == null) {
        return [];
      } else if (defaultValues != undefined) {
        _this.callOnSelect(defaultValues);

        return defaultValues;
      }

      return value;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      selectedOptions: _this.setSelectedOptions(_this.props),
      open: false,
      filter: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "UNSAFE_componentWillReceiveProps", function (props) {
      if (_this.props.id != props.id) {
        var values = props.defaultValues || [];

        _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
          selectedOptions: values,
          filter: ''
        }));

        _this.callOnSelect(values);

        return;
      }

      if (props.value !== undefined) {
        _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
          selectedOptions: props.value
        }));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionIndex", function (option) {
      return _this.state.selectedOptions.indexOf(option);
    });
    _this.areAllOptionsSelected = _this.areAllOptionsSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.optionIndex = _this.optionIndex.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getTitle = _this.getTitle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.UNSAFE_componentWillReceiveProps = _this.UNSAFE_componentWillReceiveProps.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setSelectedOptions = _this.setSelectedOptions.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BasicMultiDropDown, [{
    key: "callOnSelect",
    value: function callOnSelect(values) {
      if (this.props.onSelect) {
        this.props.returnSingleValue ? this.props.onSelect(values) : this.props.onSelect({
          target: {
            name: this.props.name,
            value: values,
            type: 'select-multiple'
          }
        });
      }
    }
  }, {
    key: "areAllOptionsSelected",
    value: function areAllOptionsSelected() {
      return this.state.selectedOptions.length === this.props.options.length;
    }
  }, {
    key: "onChange",
    value: function onChange(eventKey) {
      if (eventKey < -1) return eventKey;
      var newState = (0, _utils.clone)(this.state);

      if (eventKey === -1) {
        newState.selectedOptions = this.areAllOptionsSelected() ? [] : this.props.options.map(function (item) {
          return item.value;
        });
      } else {
        if (this.optionIndex(eventKey) > -1) {
          newState.selectedOptions.splice(this.optionIndex(eventKey), 1);
        } else {
          newState.selectedOptions.push(eventKey);
        }
      }

      this.setState(newState);
      this.callOnSelect(newState.selectedOptions);
    }
  }, {
    key: "onToggle",
    value: function onToggle(state, event, _ref2) {
      var source = _ref2.source;

      if (source !== 'select') {
        var newState = (0, _utils.clone)(this.state);
        newState.open = !this.state.open;
        this.setState(newState);
        this.props.onToggle !== undefined && this.props.onToggle(state);
      }
    }
  }, {
    key: "getNElementsTitle",
    value: function getNElementsTitle() {
      var selectedOptions = this.state.selectedOptions;
      var nSelected = this.props.nSelected;
      var internalSelectedOptions = this.props.options.filter(function (option) {
        return selectedOptions.indexOf(option.value) >= 0;
      });
      var selectOptionsNames = internalSelectedOptions.map(function (option) {
        return option.name;
      });
      var title = selectOptionsNames.slice(0, nSelected).join(', ');
      return nSelected > 0 && selectedOptions.length > nSelected ? title.concat('...') : title;
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      if (this.props.title) {
        return this.props.title;
      }

      if (this.state.selectedOptions.length === 0) {
        return this.props.placeholder;
      } else if (this.props.nSelected > 0 && this.areAllOptionsSelected()) {
        return this.props.allSelectedText;
      } else {
        return this.getNElementsTitle();
      }
    }
  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        filter: filter.target.value
      }));
    }
  }, {
    key: "createTextField",
    value: function createTextField() {
      var _this2 = this;

      return [/*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "search-field",
        header: true,
        className: "search-field",
        eventKey: -2
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        tabIndex: "-1",
        key: "search-input",
        ref: function ref(input) {
          _this2.filterInput = input;
        },
        type: "text",
        value: this.state.filter,
        onChange: this.setFilter.bind(this)
      })), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "select-all-sep",
        divider: true
      })];
    }
  }, {
    key: "createSelectAllField",
    value: function createSelectAllField() {
      var checked = this.state.selectedOptions.length === this.props.options.length;
      return [/*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "select-all",
        eventKey: -1
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        className: "select-all",
        checked: checked,
        key: "mi-sa-".concat(checked ? 'y' : 'n'),
        onChange: function onChange() {}
      }, this.props.selectAllText)), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "select-all-sep",
        divider: true
      })];
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var title = /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-label"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: this.props.icon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'title'
      }, this.getTitle()));

      var Component = this.props.tethered ? _dropdownButtonTethered["default"] : _DropdownButton["default"];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.classes.Dropdown, " dropdown-multi"),
        id: this.props.id + '-multi'
      }, /*#__PURE__*/_react["default"].createElement(Component, {
        pullRight: this.props.pullRight,
        disabled: this.props.disabled,
        onSelect: this.onChange.bind(this),
        onToggle: this.onToggle.bind(this),
        open: this.state.open,
        id: this.props.id,
        title: title
      }, this.props.filter ? this.createTextField() : null, this.props.selectAll ? this.createSelectAllField() : null, this.props.options.filter(function (item) {
        if (_this3.state.filter.length > 0) {
          var regEx = new RegExp(_this3.state.filter, 'i');
          return item.name.match(regEx);
        }

        return true;
      }).map(function (item, i) {
        var checked = _this3.state.selectedOptions.indexOf(item.value) > -1;
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: "mi-".concat(i),
          eventKey: item.value
        }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          key: "mi-cb-".concat(checked ? 'y' : 'n'),
          checked: checked,
          onChange: function onChange() {}
        }, item.name));
      })));
    }
  }]);
  return BasicMultiDropDown;
}(_react["default"].Component);

exports.BasicMultiDropDown = BasicMultiDropDown;
(0, _defineProperty2["default"])(BasicMultiDropDown, "propTypes", {
  title: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  onSelect: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
    name: _propTypes["default"].string
  })),
  defaultValues: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  value: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool])),
  //children: PropTypes.node,
  disabled: _propTypes["default"].bool,
  pullRight: _propTypes["default"].bool,
  returnSingleValue: _propTypes["default"].bool,
  filter: _propTypes["default"].bool,
  selectAll: _propTypes["default"].bool,
  selectAllText: _propTypes["default"].string,
  nSelected: _propTypes["default"].number,
  allSelectedText: _propTypes["default"].string,
  icon: _propTypes["default"].object,
  tethered: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(BasicMultiDropDown, "defaultProps", {
  selectAllText: 'Select all...',
  allSelectedText: 'All selected',
  placeholder: 'Choose...',
  nSelected: 3,
  tethered: false
});
var MultiDropDown = (0, _ThemeProvider.withStyles)(_style["default"])(BasicMultiDropDown);
exports.MultiDropDown = MultiDropDown;
var _default = MultiDropDown;
exports["default"] = _default;
//# sourceMappingURL=bootstrap-multi.js.map